import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export class SimpleMapCoord {
  constructor(size) {
    _defineProperty(this, "size", 10000);
    this.size = size ? size : 10000;
  }
  setSize(size) {
    this.size = size;
  }
  getSize() {
    return [this.size, this.size];
  }

  /**
   * coord
   * ^ y (y > 0)
   * |
   * |
   * |
   * |(x = 0, y = 0)
   * ---------------> x (x > 0)
   */

  /***
   * lng: [-180, 180] 360
   * lat: [-85.05112877980659, 85.05112877980659] 170.10225755961318
   */

  mercatorXfromLng(lng) {
    // (0 - 1) * this.size
    return (180 + lng) / 360 * this.size;
  }
  mercatorYfromLat(lat) {
    // (0 - 1) * this.size
    return (1 - (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360))) / 360) * this.size;
  }
  lngFromMercatorX(x) {
    return x / this.size * 360 - 180;
  }
  latFromMercatorY(y) {
    const y2 = 180 - (1 - y / this.size) * 360;
    return 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
  }
  project(lnglat) {
    const x = this.mercatorXfromLng(lnglat[0]);
    const y = this.mercatorYfromLat(lnglat[1]);
    return [x, y];
  }
  unproject(xy) {
    const lng = this.lngFromMercatorX(xy[0]);
    const lat = this.latFromMercatorY(xy[1]);
    return [lng, lat];
  }
}